import React from 'react'

const FinishedBlock: React.FC = () => {
  return (
    <div className='basicUpdate'>
        <h1>Call Complete</h1>
        <p>You can now close this window and continue</p>
    </div>
  )
}

export default FinishedBlock
